import { render, staticRenderFns } from "./IconSvgChart.vue?vue&type=template&id=9260e84a&scoped=true&"
import script from "./IconSvgChart.vue?vue&type=script&lang=js&"
export * from "./IconSvgChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9260e84a",
  null
  
)

export default component.exports